<script>
	let toggleId = 0;

	export default {
		props: {
			buttonFlags: {
				required: false,
				default: ''
			},
			options: {
				required: true,
				type: Array
			},
			legend: {
				required: false,
				type: String
			},
			alignment: {
				default: 'left',
				type: String
			}
		},
		computed: {
			buttonStyles() {
				return 'toggle-button button ' + this.buttonFlags;
			}
		},
		data() {
			return {
				toggleId: 'toggle' + toggleId++
			};
		}
	};
</script>
<template>
	<fieldset
		class="toggle-buttons-component toggle-buttons toggle-buttons-inline"
		:class="`toggle-buttons-${alignment}`">
		<legend
			v-if="legend"
			v-html="legend"></legend>
		<label
			v-for="option in options"
			:key="option.value"
			:data-text="option.label"
			:class="{
				[buttonStyles]: true,
				active: option.selected,
				disabled: !!option.disabled
			}">
			<input
				:disabled="!!option.disabled"
				type="radio"
				@change="$emit('click-item', option)"
				:checked="option.selected"
				:value="option.value"
				:name="toggleId" />
			{{ option.label }}
		</label>
	</fieldset>
</template>
<style lang="scss">
	.toggle-buttons-component {
		margin: 0;
	}
</style>
